var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnowYourCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_53872",
    "data-name": "Group 53872",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 281.865,
    height: 176.548,
    viewBox: "0 0 281.865 176.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8187",
    "data-name": "Rectangle 8187",
    width: 281.865,
    height: 176.548,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53871",
    "data-name": "Group 53871",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85739",
    "data-name": "Path 85739",
    d: "M256.281,55.1s1.084,8.571-3.054,12.118c-4.55,3.9-8.4,19.194,8.182,23.4s35.681,5.851,36.744-16.9c.985-21.083-3.448-27.389-8.522-32.364C284.854,36.677,256.281,55.1,256.281,55.1",
    transform: "translate(-38.745 -6.309)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85740",
    "data-name": "Path 85740",
    d: "M260.41,67.48s.495,6.932,6.437,5.942-1.733-8.665-6.437-5.942",
    transform: "translate(-40.471 -10.397)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85741",
    "data-name": "Path 85741",
    d: "M300.533,60.289s4.377,5.4-.636,8.736-4.659-7.508.636-8.736",
    transform: "translate(-46.055 -9.37)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85742",
    "data-name": "Path 85742",
    d: "M274.983,40.879S260.625,44.1,261.862,56.722c1.546,15.77,12.626,24.261,20.795,23.518s12.265-14.79,10.4-25.994c-1.237-7.426-5.942-14.854-18.072-13.368",
    transform: "translate(-40.685 -6.323)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85743",
    "data-name": "Path 85743",
    d: "M273.021,42.713s4.008,17.632,23.777,15.763c0,0,1.6-21.907-17.1-21.373s-25.38,7.481-20.839,26.984c0,0,15.5-1.871,14.16-21.373",
    transform: "translate(-40.017 -5.765)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85744",
    "data-name": "Path 85744",
    d: "M275.945,41.793s.742,16.339,16.586,19.062",
    transform: "translate(-42.885 -6.495)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85745",
    "data-name": "Path 85745",
    d: "M246.732,108.134s6.932,35.318,13.863,34.988,1.981-33.007,1.981-33.007Z",
    transform: "translate(-38.345 -16.805)",
    fill: "#ffa968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85746",
    "data-name": "Path 85746",
    d: "M260.385,143.536c-7.132,0-13.573-31.773-14.288-35.414l-.139-.709,16.956,2.119.059.393c.167,1.1,4.039,27.056-.425,32.5a2.769,2.769,0,0,1-2.049,1.106l-.114,0m-13.116-34.9c.468,2.272,2.036,9.625,4.178,16.866,4.353,14.714,7.442,16.991,8.933,16.991.023,0,.046,0,.068,0a1.741,1.741,0,0,0,1.288-.722c3.891-4.749.731-27.976.257-31.291Z",
    transform: "translate(-38.225 -16.693)",
    fill: "#e58645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85747",
    "data-name": "Path 85747",
    d: "M323.136,97.24s1.862,35.944-4.942,37.309-9.945-31.536-9.945-31.536Z",
    transform: "translate(-47.905 -15.112)",
    fill: "#ffa968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85748",
    "data-name": "Path 85748",
    d: "M317.678,134.977a2.89,2.89,0,0,1-1.74-.627c-5.654-4.2-8.208-30.316-8.314-31.426l-.037-.394,15.932-6.179.037.724c.193,3.725,1.682,36.436-5.362,37.849a2.63,2.63,0,0,1-.516.052m-8.97-31.758c.345,3.332,2.927,26.63,7.856,30.29a1.738,1.738,0,0,0,1.425.388c1.437-.289,3.947-3.1,4.6-18.668.317-7.545.051-15.056-.047-17.375Z",
    transform: "translate(-47.802 -14.974)",
    fill: "#e58645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85749",
    "data-name": "Path 85749",
    d: "M265.314,130.18s-23.766,22.775-22.116,63.7h68.657s10.232-45.55-8.912-70.306-37.629,6.6-37.629,6.6",
    transform: "translate(-37.783 -17.726)",
    fill: "#ffa968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85750",
    "data-name": "Path 85750",
    d: "M282.542,142.529a166.935,166.935,0,0,0,23.826,4.563c3.215.428,6.517.824,9.857,1.109-1.6-8.872-4.671-17.587-10.111-24.622-19.144-24.756-37.628,6.6-37.628,6.6a51.571,51.571,0,0,0-4.969,5.863c6.3,2.277,12.579,4.646,19.025,6.486",
    transform: "translate(-40.953 -17.726)",
    fill: "#e58645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85751",
    "data-name": "Path 85751",
    d: "M312.1,194.2H242.754l-.014-.374c-1.608-39.861,21.1-62.885,22.2-63.963a48.779,48.779,0,0,1,6.045-7.789c3.477-3.634,8.948-8.051,15.264-8.448,5.989-.377,11.7,2.866,16.936,9.64,19.036,24.616,9.087,70.173,8.984,70.63Zm-68.592-.779h67.966c.836-4.018,9.094-46.405-8.9-69.679-5.071-6.557-10.552-9.709-16.269-9.339-11.638.731-20.627,15.749-20.716,15.9l-.066.083c-.236.226-23.474,23-22.01,63.034",
    transform: "translate(-37.712 -17.655)",
    fill: "#e58645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85752",
    "data-name": "Path 85752",
    d: "M245.5,84.957l-.33-10.893s28.387,1.32,32.348,12.873c0,0,13.2-14.854,28.387-17.494l5.611,28.717Z",
    transform: "translate(-38.102 -10.792)",
    fill: "#ffdebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85753",
    "data-name": "Path 85753",
    d: "M240.87,77.26l31.357,6.6,2.971,44.561L242.19,120.17Z",
    transform: "translate(-37.434 -12.007)",
    fill: "#a9cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85754",
    "data-name": "Path 85754",
    d: "M319.391,72.462,289.2,83.211l3.035,44.556,31.6-12.606Z",
    transform: "translate(-44.945 -11.261)",
    fill: "#a9cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85755",
    "data-name": "Path 85755",
    d: "M278,85.015l10.562-.33,2.641,47.2s-6.272,2.31-11.883-.33Z",
    transform: "translate(-43.204 -13.161)",
    fill: "#77aac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85756",
    "data-name": "Path 85756",
    d: "M278,84.975l10.556-.54.2-.01.014.208.818,11.792c.554,7.742,1.741,27.827,2.211,35.821A17.184,17.184,0,0,1,279.09,132l-.3-.13-.008-.338L278.5,119.8c-.185-10.34-.4-24.488-.5-34.827m0,0c.339,7.742,1.2,27.514,1.475,34.984l.378,11.542-.307-.468a15.071,15.071,0,0,0,8.616.96,18.217,18.217,0,0,0,2.842-.685l-.374.569c-.416-7.826-1.47-27.842-1.775-35.412l-.5-11.809.216.2Z",
    transform: "translate(-43.204 -13.121)",
    fill: "#77aac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85757",
    "data-name": "Path 85757",
    d: "M236.877,99.946s-.943-6.3,1.024-7.182,16.037,4.481,3.131,2.993c0,0,21.924,4.861.659,2.912,0,0,17.565,3.191.5,2.11,0,0,13.79,3.312-.807,1.768l-.568,4.493s-1.727,1.124-3.942-7.094",
    transform: "translate(-36.778 -14.401)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85758",
    "data-name": "Path 85758",
    d: "M236.849,99.891c-.284-1.928-1.285-7.7,1.848-7.581a16.69,16.69,0,0,1,7.856,2.541c1.785,2.4-4.542,1.5-5.615,1.423l.191-1.136c3.41.859,6.933,1.285,10.1,2.924a.839.839,0,0,1-.416,1.521c-3.068.41-6.149-.135-9.205-.336l.171-1.258a48.323,48.323,0,0,1,7.815,1.946c.26.165.486.2.587.7a.666.666,0,0,1-.333.608,1.742,1.742,0,0,1-.7.191,54.3,54.3,0,0,1-7-.3l.122-.808a35.805,35.805,0,0,1,5.488,1.786,1.2,1.2,0,0,1,.525.417c.4,1.07-3.088.392-3.677.4-1.085-.112-2.163-.278-3.24-.437a42.2,42.2,0,0,0,6.443.1c.041-.006.1-.057.041-.005a.187.187,0,0,0-.023.17c.014.024,0,.009-.007,0a33.014,33.014,0,0,0-5.743-1.636l.122-.808a46.27,46.27,0,0,0,7.065-.024.43.43,0,0,0-.2.419c.035.25.122.266.121.282.025.018-.041-.024-.088-.044a54.835,54.835,0,0,0-7.545-1.707l.171-1.258a64.75,64.75,0,0,0,8.534.385,2.184,2.184,0,0,0,.224-.041c.048.014.124-.1-.086.113a.559.559,0,0,0-.031.564.4.4,0,0,0,.043.061,1.22,1.22,0,0,0-.155-.1,67.077,67.077,0,0,0-9.37-2.7l.191-1.137c.916.116,1.835.209,2.744.274a8.821,8.821,0,0,0,2.142-.053.28.28,0,0,0-.045.19c.024.1.019.03-.037-.019a14.488,14.488,0,0,0-4.544-2.037,9.449,9.449,0,0,0-3.264-.545,1.94,1.94,0,0,0-1,1.436,17.748,17.748,0,0,0-.214,5.516",
    transform: "translate(-36.75 -14.346)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85759",
    "data-name": "Path 85759",
    d: "M330.512,91.2s1.188-6.26-.745-7.216-16.2,3.853-3.244,2.868c0,0-22.1,4.006-.772,2.885,0,0-17.676,2.505-.584,2.089,0,0-13.909,2.773.739,1.8l.392,4.511s1.682,1.191,4.215-6.935",
    transform: "translate(-49.183 -13.033)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85760",
    "data-name": "Path 85760",
    d: "M330.393,91.145a17.768,17.768,0,0,0,0-5.52,1.938,1.938,0,0,0-.947-1.474,9.472,9.472,0,0,0-3.283.417,14.508,14.508,0,0,0-4.62,1.86c-.057.045-.066.115-.037.017a.281.281,0,0,0-.038-.192c-.031-.042-.03-.034-.016-.03a6.866,6.866,0,0,0,2.155.166c.91-.03,1.832-.087,2.753-.167l.146,1.143a67.268,67.268,0,0,0-9.468,2.336,1.615,1.615,0,0,0-.162.092.187.187,0,0,0,.049-.061.56.56,0,0,0-.009-.565c-.2-.221-.131-.1-.082-.116.056.018.142.033.223.05a64.8,64.8,0,0,0,8.541-.054l.122,1.264a55.055,55.055,0,0,0-7.6,1.412c-.047.019-.116.057-.09.041,0-.016.088-.029.132-.276a.431.431,0,0,0-.178-.427,46.229,46.229,0,0,0,7.058.3l.09.812a33.037,33.037,0,0,0-5.8,1.41c-.008.007-.021.02-.006,0a.184.184,0,0,0-.016-.17c-.06-.055,0,0,.041.006a41.685,41.685,0,0,0,6.443.152c-1.083.117-2.166.24-3.254.31-.543-.014-4.569.525-3.531-.7,1.836-1.01,3.96-1.288,5.966-1.815l.09.812a54.229,54.229,0,0,1-7.01.024,1.735,1.735,0,0,1-.694-.219c-.56-.376-.3-1.084.3-1.292a48.3,48.3,0,0,1,7.884-1.64l.122,1.264c-3.062.083-6.161.507-9.211-.022a.838.838,0,0,1-.357-1.535c3.225-1.516,6.763-1.8,10.2-2.53l.146,1.143c-1.056.03-7.436.687-5.555-1.64a16.66,16.66,0,0,1,7.949-2.234c3.138.008,1.906,5.732,1.552,7.647",
    transform: "translate(-49.064 -12.977)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85761",
    "data-name": "Path 85761",
    d: "M144.1,143.793l-5.168,54.712h50.837l2.581-53.408Z",
    transform: "translate(-21.591 -22.347)",
    fill: "#ffdebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85762",
    "data-name": "Path 85762",
    d: "M192.292,160.256l.732-15.159-48.25-1.3-1.5,15.854Z",
    transform: "translate(-22.267 -22.347)",
    fill: "#fcc8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85763",
    "data-name": "Path 85763",
    d: "M169.979,190.053,168.816,205.4h25.6l.834-17.243Z",
    transform: "translate(-26.236 -29.242)",
    fill: "#fcc8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85764",
    "data-name": "Path 85764",
    d: "M147.791,57.357l10.089-.967s-3.319-47.3-.83-48.768S176.937,7.133,179.665,15c1.2,3.468,8.193,34.273-6.7,37.4l.148,4.807s5.654-.2,10.334-.177S181.469,69.069,165.75,67.8s-17.959-10.443-17.959-10.443",
    transform: "translate(-22.968 -1.096)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85765",
    "data-name": "Path 85765",
    d: "M183.445,62.47c-4.682-.019-10.334.177-10.334.177l-.148-4.807c-9.886-.124-14.167-8.465-16.191-15.774.416,10.078,1.108,19.767,1.108,19.767l-10.089.967s2.241,9.174,17.959,10.442,22.376-10.754,17.695-10.773",
    transform: "translate(-22.968 -6.538)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85766",
    "data-name": "Path 85766",
    d: "M157.788,34.158s-2.878-4.032-4.872.138c-2.567,5.359,2.743,10.943,6.36,6.853s-1.487-6.991-1.487-6.991",
    transform: "translate(-23.66 -5.036)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85767",
    "data-name": "Path 85767",
    d: "M156.814,46.268c.372,4.8.811,11.48,1.264,16.192l.027.286-.291.03-10.08,1.06.339-.476a9.935,9.935,0,0,0,1.63,3.011c5.056,6.348,15.059,7.948,22.708,6.792,4.49-.852,9.283-3.04,11.635-7.111.691-1.318.814-2.829-1.124-2.65-1.8-.052-7.994-.012-9.9-.008-.125.007-.084.009-.1-.092l-.42-4.8.733-.023-.123,4.815-.1-.092c2.4-.141,4.8-.232,7.2-.3.545-.013,2.165-.055,2.7-.061,1.082-.133,2.24.358,2.209,1.637-.323,3.2-3.216,5.424-5.7,7.015a23.587,23.587,0,0,1-14.159,2.815c-7.205-.579-15.747-3.608-18.088-11.2l.477-.041,10.1-.874-.264.316c-.367-5.41-.581-10.822-.679-16.241",
    transform: "translate(-22.874 -7.191)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85768",
    "data-name": "Path 85768",
    d: "M150.69,8.746s-2.445-10.514-8.313-7.58,1.711,9.781,1.711,9.781-1.222-8.557-4.645-2.2,9.291,8.069,11.247,0",
    transform: "translate(-21.581 -0.101)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85769",
    "data-name": "Path 85769",
    d: "M143.462,14.626a5.649,5.649,0,0,1-4.585-1.921,3.88,3.88,0,0,1-.016-4.318,8.639,8.639,0,0,1,1.223-1.8,4.864,4.864,0,0,1-.4-3.559A4.323,4.323,0,0,1,142.032.576a4.444,4.444,0,0,1,4.035-.169c3.518,1.654,4.995,7.852,5.057,8.115a.543.543,0,0,1,0,.253,7.514,7.514,0,0,1-5.966,5.679,8.57,8.57,0,0,1-1.694.172m-.94-13.07a3.283,3.283,0,0,0-1.8,1.817,4.089,4.089,0,0,0,.512,3.089.548.548,0,0,1-.133.663,6.4,6.4,0,0,0-1.279,1.781,2.817,2.817,0,0,0-.069,3.147c.9,1.217,3.034,1.765,5.182,1.328a6.418,6.418,0,0,0,5.088-4.735c-.222-.864-1.635-5.937-4.425-7.247a3.354,3.354,0,0,0-3.079.158",
    transform: "translate(-21.48 0)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85770",
    "data-name": "Path 85770",
    d: "M159.594,31.968a86.384,86.384,0,0,1-.484-10.332c1.579-.921,3.5-3.071,2.483-7.976,0,0,8.964-6.846,18.214.692,0,0-.938-11.818-16.91-11.451-14.181.326-18.093,16.464-10.105,25.755,0,0,2.288-1.659,3.9.128a45.984,45.984,0,0,0,.215,6.657",
    transform: "translate(-23.111 -0.449)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85771",
    "data-name": "Path 85771",
    d: "M179.742,14.264A13.2,13.2,0,0,0,169.051,3.891a26.045,26.045,0,0,0-3.464-.528l-1.762-.029c-13.866-.573-18.959,15.222-11.1,25.233-8.068-8.4-4.872-24.1,7.443-26.021a26.271,26.271,0,0,1,5.489-.149l1.814.24c6.024.713,11.795,5.322,12.269,11.627",
    transform: "translate(-23.046 -0.362)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85772",
    "data-name": "Path 85772",
    d: "M157.321,41.438c-.773-.086-2.378-.721-1.569-1.7a2.236,2.236,0,0,1,.78-.508l-.258.294a16.306,16.306,0,0,0,.093-2.352c-.046-.791-.2-2.244-1.224-2.086-.932.493-1.246,1.853-1.653,2.85-.018-1.278.038-2.859,1.3-3.66,3.084-.856,2.818,3.85,2.2,5.649a3.128,3.128,0,0,0-.772.285c-.07.047-.1.064-.1.088.1.5.795.83,1.205,1.139",
    transform: "translate(-23.854 -5.311)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85773",
    "data-name": "Path 85773",
    d: "M199.091,95.193s6.846,30.319,15.649,28.689S209.523,82.8,209.523,82.8Z",
    transform: "translate(-30.941 -12.869)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85774",
    "data-name": "Path 85774",
    d: "M182.4,64.828s13.937-3.423,21.028,5.135,8.558,21.028,8.558,21.028l-15.16,5.134Z",
    transform: "translate(-28.346 -9.97)",
    fill: "#a9cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85775",
    "data-name": "Path 85775",
    d: "M194.264,87.568l-.361.275,4.708,10.213,15.16-5.134a49.627,49.627,0,0,0-5.377-16.342c-4.6,3.773-9.371,7.355-14.129,10.988",
    transform: "translate(-30.135 -11.901)",
    fill: "#77aac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85776",
    "data-name": "Path 85776",
    d: "M223.962,31.328s-2.707-10.024,4.747-13.451c0,0,2.3,9.238-4.747,13.451",
    transform: "translate(-34.732 -2.778)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85777",
    "data-name": "Path 85777",
    d: "M229.141,24.18a16.323,16.323,0,0,0-.095-6.3,8.337,8.337,0,0,0-3.394,2.777c1.159,1.18,2.315,2.362,3.488,3.526",
    transform: "translate(-35.069 -2.778)",
    fill: "#ffa968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85778",
    "data-name": "Path 85778",
    d: "M220.888,32.95c-1.329,1.349-3.5,6.036-6.885,16.34-4.3,13.1-8.919,30.3-7.777,30.676s7.615-16.223,11.913-29.319c3.182-9.694,4.278-14.748,4.171-16.874q-.717-.4-1.421-.823",
    transform: "translate(-32.022 -5.121)",
    fill: "#ffa968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85779",
    "data-name": "Path 85779",
    d: "M222.847,32.95c-.937.951-2.291,3.559-4.191,8.613q1.889.772,3.761,1.583c1.41-4.954,1.927-7.882,1.852-9.372q-.718-.4-1.422-.823",
    transform: "translate(-33.982 -5.121)",
    fill: "#ffdebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85780",
    "data-name": "Path 85780",
    d: "M215.485,49.973s7.172-.978,8.8,2.608,3.586,64.224-6.194,66.18c-7.6,1.52-15.649-6.846-4.564-54.77,0,0-4.89-1.3-2.934-3.586,0,0-2.608-2.608.978-3.586,0,0-1.956-2.608,1.3-2.934,0,0-3.26-3.26,2.608-3.912",
    transform: "translate(-32.338 -7.747)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85781",
    "data-name": "Path 85781",
    d: "M218.02,118.727c-15.313,2.573-9.625-31.338-8.151-39.936.9-5.011,1.978-9.986,3.136-14.938l.332.552c-1.806-.457-5.024-2.131-3.144-4.315l.022.588c-1.034-1.019-1.556-2.893-.046-3.747a5.126,5.126,0,0,1,1.232-.5l-.2.582c-1.215-1.747-.648-3.324,1.569-3.475l-.193.542c-3-3.57,1.583-4.508,4.421-4.437,2.573.033,5.938.3,7.215,2.909-1.4-2.475-4.672-2.6-7.2-2.534-2.117.084-6.693.7-3.981,3.612l.416.438-.611.1c-2.047.215-1.829,1.436-.742,2.8l-.5.174c-2.069.566-1.928,1.825-.511,3.189-.261.346-.667.857-.555,1.241.494,1.253,2.259,1.672,3.471,2.059l-.1.428c-1.951,9.547-13.492,57.008,4.113,54.666",
    transform: "translate(-32.266 -7.714)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85782",
    "data-name": "Path 85782",
    d: "M152.938,65.116s2.934,10.025,12.47,9.78,9.78-10.024,9.78-10.024,14.181-2.446,16.871,4.156,1.223,75.8,1.223,75.8l-52.57-1.222s-7.335-72.864-3.668-75.554,15.893-2.934,15.893-2.934",
    transform: "translate(-21.139 -10.013)",
    fill: "#a9cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85783",
    "data-name": "Path 85783",
    d: "M170.575,99.423c-7.335-4.73-13.554-10.91-19.782-16.976-4.562-4.444-9.235-9.132-12.808-14.491a6.485,6.485,0,0,0-1.13.641c-3.668,2.69-1.325,75.554-1.325,75.554l57.562,1.223s.374-17.669.4-36a84.347,84.347,0,0,1-22.915-9.949",
    transform: "translate(-20.948 -10.561)",
    fill: "#77aac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85784",
    "data-name": "Path 85784",
    d: "M136.8,68.716c-.938,1.255-.871,3.03-1.125,4.532-.468,4.713-.544,9.454-.62,14.187-.218,10.948.153,26.775.329,37.884q.2,9.47.506,18.937l-.406-.4,28.78.63,28.779.71c-.774,1.814.579-63.534.361-63.161l0,31.73-.067,31.73v.3l-.3-.005c-14.355-.253-43.217-.781-57.565-1.1l-.394-.008-.012-.394c-.35-12.633-.617-25.265-.611-37.9.016-9.476.048-18.964.688-28.423a60.959,60.959,0,0,1,.816-7.062,4.5,4.5,0,0,1,.846-2.18",
    transform: "translate(-20.895 -10.679)",
    fill: "#77aac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85785",
    "data-name": "Path 85785",
    d: "M130.758,71.611s-17.85,40.344-11.981,47.68,50.614-10.514,50.614-10.514L159.121,101.2l-22.25,2.934L147.63,75.523Z",
    transform: "translate(-18.275 -11.129)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85786",
    "data-name": "Path 85786",
    d: "M152.808,121.442c10.9-3.385,20.521-7.221,20.521-7.221l-10.269-7.579-20.127,2.654c1.977,4.866,5.632,8.773,9.875,12.147",
    transform: "translate(-22.213 -16.573)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85787",
    "data-name": "Path 85787",
    d: "M139.768,98.926l8.8-23.4L131.7,71.611s-4.359,9.854-8.061,20.707a41,41,0,0,0,16.131,6.608",
    transform: "translate(-19.215 -11.129)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85788",
    "data-name": "Path 85788",
    d: "M125.167,114.135c5.112-3.564,11.381-4.957,17.461-5.836a166.2,166.2,0,0,1,18.4-1.651c-5.256.88-12.9,1.913-18.247,2.687-6.069.849-12.116,1.978-17.614,4.8",
    transform: "translate(-19.452 -16.574)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85789",
    "data-name": "Path 85789",
    d: "M150.517,64.482s-12.959-10.758-21.273,2.445-8.8,18.094-8.8,18.094,13.448,9.291,24.7,10.758Z",
    transform: "translate(-18.718 -9.379)",
    fill: "#a9cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85790",
    "data-name": "Path 85790",
    d: "M137.623,60.574c-3.905.8-6.764,3.812-8.653,7.155a115.472,115.472,0,0,0-5.57,10.214,31.742,31.742,0,0,0-2.638,7.153l-.171-.371a83.749,83.749,0,0,0,18,9.146,42.693,42.693,0,0,0,6.509,1.623l-.359.265c1.1-6.024,2.224-12.046,3.43-18.051-.884,6.166-1.855,12.317-2.844,18.465A45.69,45.69,0,0,1,132,92.074a83.663,83.663,0,0,1-12.083-6.83,30.47,30.47,0,0,1,2.81-7.622,105.02,105.02,0,0,1,5.834-10.144c1.976-3.317,5.115-6.333,9.057-6.9",
    transform: "translate(-18.637 -9.414)",
    fill: "#77aac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85791",
    "data-name": "Path 85791",
    d: "M184.459,101.554c-11.247-13.692-14.426-13.448-18.583-10.514s-6.357,1.712-6.357,1.712c-7.824-4.646-13.535-10.363-18.339-1.956-4.89,8.557,22.495,39.365,35.7,37.654s18.828-13.2,7.58-26.9m-8.041-.872c-.694,1.415-3.756,1.335-6.839-.177s-5.019-3.886-4.325-5.3,3.756-1.335,6.839.177,5.019,3.886,4.325,5.3",
    transform: "translate(-21.851 -13.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85792",
    "data-name": "Path 85792",
    d: "M169.079,96.9s2.2-3.912,5.135-4.156,14.915,5.868,2.689,4.156c0,0-2.2,8.884-7.824,0",
    transform: "translate(-26.277 -14.412)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85793",
    "data-name": "Path 85793",
    d: "M149.3,104.147a3.586,3.586,0,1,0,3.586-3.586,3.586,3.586,0,0,0-3.586,3.586",
    transform: "translate(-23.202 -15.628)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85794",
    "data-name": "Path 85794",
    d: "M158.56,114.955a3.586,3.586,0,1,0,3.586-3.586,3.586,3.586,0,0,0-3.586,3.586",
    transform: "translate(-24.642 -17.308)",
    fill: "#a9cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85795",
    "data-name": "Path 85795",
    d: "M171.3,124.219a3.586,3.586,0,1,0,3.586-3.586,3.586,3.586,0,0,0-3.586,3.586",
    transform: "translate(-26.622 -18.748)",
    fill: "#adb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85796",
    "data-name": "Path 85796",
    d: "M184.036,124.605a3.587,3.587,0,1,0,3.587-3.586,3.587,3.587,0,0,0-3.587,3.586",
    transform: "translate(-28.601 -18.808)",
    fill: "#ffa755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85797",
    "data-name": "Path 85797",
    d: "M185.581,111.481a3.586,3.586,0,1,0,3.586-3.586,3.586,3.586,0,0,0-3.586,3.586",
    transform: "translate(-28.841 -16.768)",
    fill: "#ffa968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85798",
    "data-name": "Path 85798",
    d: "M57.83,133.934s-17.475,18.407-16.872,62.522h62.379s1.238-50.6-21.825-60.82-23.682-1.7-23.682-1.7",
    transform: "translate(-6.363 -20.298)",
    fill: "#a9cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85799",
    "data-name": "Path 85799",
    d: "M68.2,185.2a135.6,135.6,0,0,1-14.495-4.84c-3.539-1.364-7.533-2.855-10.426-5.095-1.263,4.215-2.351,20.85-2.322,28.128H68.2Z",
    transform: "translate(-6.366 -27.239)",
    fill: "#77aac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85800",
    "data-name": "Path 85800",
    d: "M88.861,138.432a29,29,0,0,0-4.94-2.795c-23.063-10.215-23.682-1.7-23.682-1.7a32.569,32.569,0,0,0-3.792,4.957,117.26,117.26,0,0,0,32.414-.459",
    transform: "translate(-8.772 -20.298)",
    fill: "#77aac6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85801",
    "data-name": "Path 85801",
    d: "M103.691,196.39l-.863-.021c.012-.5.966-50.432-21.568-60.414-13.443-5.954-19.121-5.525-21.514-4.117a2.907,2.907,0,0,0-1.562,2.053l-.014.16-.117.116c-.17.163-16.945,16.882-16.74,62.21l-.864,0c-.108-23.88,4.505-39.672,8.393-48.715,3.912-9.1,7.8-13.3,8.505-14.014a3.866,3.866,0,0,1,1.921-2.534c2.557-1.536,8.511-2.079,22.342,4.047,9.567,4.237,16.416,16.187,19.811,34.557a146.748,146.748,0,0,1,2.271,26.668",
    transform: "translate(-6.286 -20.22)",
    fill: "#6d9cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85802",
    "data-name": "Path 85802",
    d: "M47.742,177.715c6.728,2.861,14.872,5.856,21.423,7.144,3.376-.662,8.138-1.643,11.475-2.255,3.362-.623,8.184-1.5,11.526-2.006-3.248.853-8.055,1.943-11.383,2.7-3.289.756-8.087,1.726-11.434,2.453-7.578-1.39-14.8-4.472-21.607-8.036",
    transform: "translate(-7.42 -27.619)",
    fill: "#6d9cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85803",
    "data-name": "Path 85803",
    d: "M72.813,205.174q-.205-9.236-.135-18.472h.9c.041,3.079,0,6.157.006,9.236-.048,3.079-.056,6.158-.141,9.236Z",
    transform: "translate(-11.292 -29.016)",
    fill: "#6d9cbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85804",
    "data-name": "Path 85804",
    d: "M81.767,77.838s-1.724,14.216.458,13.843,11.352-5.565,13.283,3.76-11.273,27.974-11.273,27.974l-29.474-.351S49.814,94.819,57.644,92.02s12.748,4.96,12.472-7.135c-.28-12.281,11.651-7.047,11.651-7.047",
    transform: "translate(-8.271 -11.925)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85805",
    "data-name": "Path 85805",
    d: "M72.81,89.855a34.86,34.86,0,0,0,.351-4.97c.258-12.281,11.652-7.046,11.652-7.046s-.437,3.6-.592,7.128c-2.889,2.092-8.092,3.972-11.41,4.888",
    transform: "translate(-11.315 -11.925)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85806",
    "data-name": "Path 85806",
    d: "M66.949,46.555s-6.5-4.954-13.466,6.037.928,22.444,9.906,22.6,3.56-28.636,3.56-28.636",
    transform: "translate(-7.898 -7.062)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85807",
    "data-name": "Path 85807",
    d: "M63.377,75.558H63.3a13.312,13.312,0,0,1-11.234-7.311c-2.678-4.97-2.33-10.794.956-15.979,2.688-4.242,5.637-6.677,8.763-7.238a7.187,7.187,0,0,1,5.356,1.084l.137.1.032.171c.168.892,4.057,21.923-.8,27.672a3.957,3.957,0,0,1-3.134,1.5M63.113,45.81a6.692,6.692,0,0,0-1.194.109c-2.86.522-5.6,2.82-8.141,6.831-3.106,4.9-3.443,10.394-.923,15.071a12.578,12.578,0,0,0,10.458,6.837,3.1,3.1,0,0,0,2.511-1.176c4.352-5.156,1.01-24.638.633-26.743a6.41,6.41,0,0,0-3.343-.929",
    transform: "translate(-7.814 -6.979)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85808",
    "data-name": "Path 85808",
    d: "M73.09,49.08S61.237,47.99,59.858,61.153C58.1,77.9,68.2,88.009,77.9,80.58s11-31.893-4.807-31.5",
    transform: "translate(-9.272 -7.624)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85809",
    "data-name": "Path 85809",
    d: "M87.257,72.084s.734-7.323,3.957-5.888,1.173,11.215-4.268,8.422",
    transform: "translate(-13.512 -10.259)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85810",
    "data-name": "Path 85810",
    d: "M88.217,43.524s-9.6-8.668.465-12.847,10.061,10.215,3.405,12.383c0,0,3.25.619,6.191-5.108,0,0-1.083,10.526-10.061,5.573",
    transform: "translate(-13.068 -4.65)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85811",
    "data-name": "Path 85811",
    d: "M88.207,43.47c-3.366-3.019-6.585-8.765-1.647-11.955,4.693-3.291,10.491-2.68,10.574,4.036.007,3.224-1.687,6.772-4.937,7.828l-.047-.758a3.605,3.605,0,0,0,1.815-.366c2.228-1.045,3.5-3.371,4.681-5.424-.66,6.187-4.277,10.217-10.439,6.638m0,0c5.44,3.156,9.213.224,9.851-5.594l.4.118-.5.95C96.693,41.105,94.8,43.524,92,43.392l-1.752-.171,1.7-.587c2.834-1.011,4.255-4.227,4.318-7.087.068-6.1-5.28-6.394-9.49-3.7C81.789,34.794,85,40.474,88.207,43.47",
    transform: "translate(-13.058 -4.596)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85812",
    "data-name": "Path 85812",
    d: "M91.08,42.68a3.25,3.25,0,1,1-3.251-3.251A3.251,3.251,0,0,1,91.08,42.68",
    transform: "translate(-13.145 -6.128)",
    fill: "#a9cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85813",
    "data-name": "Path 85813",
    d: "M67.9,45.206s-.155,17.181,16.871,21.36c0,0-.233-4.762,3.1-3.87s1.238,5.573,1.238,5.573,9.287-9.442.309-21.515C81.762,36.46,67.9,45.206,67.9,45.206",
    transform: "translate(-10.553 -6.487)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85814",
    "data-name": "Path 85814",
    d: "M89.03,68.189a16.536,16.536,0,0,0,3.952-10.762,18.127,18.127,0,0,0-4.057-10.653A11.688,11.688,0,0,0,79,42.1a24.016,24.016,0,0,0-10.953,3.371l.192-.344A24.936,24.936,0,0,0,69.5,52.2,21.333,21.333,0,0,0,84.7,66.486C74.313,64.324,67.8,55.562,67.413,45.123L67.4,44.9l.2-.12c5.1-2.973,11.649-4.953,17.3-2.335,5.4,2.743,8.505,9.08,8.581,14.985A16.177,16.177,0,0,1,89.03,68.189",
    transform: "translate(-10.475 -6.407)",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85815",
    "data-name": "Path 85815",
    d: "M62.148,93.425s-2.372,12.487,6.811,13.466c11.609,1.239,14.7-13.776,14.7-13.776s6.656-5.107,11.454.774S93.57,125,88.771,131.038l-36.065-2.323s-8.2-38.542,9.442-35.291",
    transform: "translate(-7.895 -14.151)",
    fill: "#ffa755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85816",
    "data-name": "Path 85816",
    d: "M95.142,93.9a7.124,7.124,0,0,0-4.664-2.768c-.6,4.311-4.117,8.185-7.108,11.026a40.2,40.2,0,0,1-12.778,8.411c-6.319,2.525-12.95,3.666-19.632,4.6a102.442,102.442,0,0,0,1.769,13.556L88.8,131.049c4.8-6.036,11.144-31.267,6.346-37.148",
    transform: "translate(-7.92 -14.163)",
    fill: "#ff9247"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85817",
    "data-name": "Path 85817",
    d: "M96.639,99.781a60.394,60.394,0,0,1-7.549,33.106c-10.771-.814-25.811-2.345-36.469-2.354h-.376l-.049-.37c-1.319-10.22-4-21.443.843-31.165-2.165,4.834-2.547,10.207-2.175,15.426.35,5.238,1.443,10.394,2.181,15.624l-.424-.37c12.129-.058,24.192,1.318,36.253,2.312l-.419.227a63.989,63.989,0,0,0,8.183-32.436",
    transform: "translate(-7.811 -15.385)",
    fill: "#f9721a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85818",
    "data-name": "Path 85818",
    d: "M26.469,94.586S.232,93.426,0,67.653c0,0,26.7,0,26.469,26.933",
    transform: "translate(0 -10.514)",
    fill: "#adb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85819",
    "data-name": "Path 85819",
    d: "M32.161,71.483s-15.788-11.609-8.59-32.969c0,0,18.342,10.448,8.59,32.969",
    transform: "translate(-3.371 -5.986)",
    fill: "#adb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85820",
    "data-name": "Path 85820",
    d: "M40.608,76.481S32.946,52.1,48.27,36.314c0,0,9.752,17.414-7.662,40.167",
    transform: "translate(-6.013 -5.644)",
    fill: "#adb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85821",
    "data-name": "Path 85821",
    d: "M43.378,98.128S39.9,79.322,56.381,77c0,0-.7,17.645-13,21.128",
    transform: "translate(-6.694 -11.967)",
    fill: "#adb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85822",
    "data-name": "Path 85822",
    d: "M33.011,115.014a1,1,0,0,1-.993-.944C30.439,83.4,7,70.21,6.761,70.081a1,1,0,0,1,.957-1.746,56.626,56.626,0,0,1,24.046,32.1c-.579-13.922-2.406-35.693-8.047-51.316a1,1,0,0,1,1.872-.677c9.013,24.959,8.425,65.195,8.418,65.6a1,1,0,0,1-.978.976h-.018",
    transform: "translate(-0.97 -7.426)",
    fill: "#8c9690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85823",
    "data-name": "Path 85823",
    d: "M39.59,111.171a.994.994,0,0,1-.986-.877c-2.545-21.282,5.922-60.878,6.284-62.554a1,1,0,0,1,1.946.421c-.072.333-5.872,27.457-6.627,48.8a39.769,39.769,0,0,1,9.581-17.192,1,1,0,0,1,1.434,1.381c-11.612,12.058-10.648,28.795-10.637,28.962a1,1,0,0,1-.9,1.057.856.856,0,0,1-.093,0",
    transform: "translate(-5.925 -7.297)",
    fill: "#8c9690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85824",
    "data-name": "Path 85824",
    d: "M23.667,112.8l3.743,24.2H48.531l3.742-25.478Z",
    transform: "translate(-3.678 -17.333)",
    fill: "#ffa968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85825",
    "data-name": "Path 85825",
    d: "M51.077,119.671l1.2-8.144L23.666,112.8l.916,5.917c8.828.446,17.66.74,26.5.953",
    transform: "translate(-3.678 -17.333)",
    fill: "#ff9247"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8186",
    "data-name": "Rectangle 8186",
    width: 35.291,
    height: 6.624,
    transform: "translate(15.711 90.883)",
    fill: "#ffa968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85826",
    "data-name": "Path 85826",
    d: "M91.2,110.2S82.375,138.3,77.267,140.388s-24.38-15.323-24.38-15.323-19.86,4.449-3.66-1.026c0,0-17,2.651-.518-1.76,0,0-13.467,1.857-.233-1.857,0,0-15.788.465,4.644-2.322,0,0-9.519-8.591,2.089-.232l17.646,10.215S80.749,97.667,84,96.506s7.2,13.7,7.2,13.7",
    transform: "translate(-6.452 -14.988)",
    fill: "#cc7b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85827",
    "data-name": "Path 85827",
    d: "M83.41,114.3a30.916,30.916,0,0,0,8.353,4.284c.924.3,1.856.568,2.792.8,1.857-5.137,3.129-9.186,3.129-9.186s-3.948-14.859-7.2-13.7c-1.727.617-4.766,9.494-7.234,17.679.052.039.1.08.157.119",
    transform: "translate(-12.938 -14.988)",
    fill: "#853f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85828",
    "data-name": "Path 85828",
    d: "M81.371,109.572S86.479,89.141,96,91s2.554,20.431.928,24.61a27.044,27.044,0,0,1-15.556-6.036",
    transform: "translate(-12.646 -14.124)",
    fill: "#ffa755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85829",
    "data-name": "Path 85829",
    d: "M95.925,91.02c9.61,1.9,3.527,19.127,1.264,25.109a26.856,26.856,0,0,1-16.111-6.265l-.178-.144.061-.21a46.15,46.15,0,0,1,4.861-11.36,56.754,56.754,0,0,0-4.188,11.529l-.118-.354a27.665,27.665,0,0,0,15.338,5.815l-.458.313c2.145-5.787,8.427-22.115-.471-24.433",
    transform: "translate(-12.573 -14.146)",
    fill: "#f9721a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85830",
    "data-name": "Path 85830",
    d: "M20.9,124.482s-2.1-4.617-.785-5.72,13.253-.076,3.05,1.606c0,0,17.842-1.071,1.141,2.085,0,0,14.141-1.4.846,1.5,0,0,11.278-.48-.232,1.531l.548,3.562s-1.076,1.238-4.568-4.568",
    transform: "translate(-3.058 -18.386)",
    fill: "#cc7b62"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowYourCommunity);
export default __webpack_public_path__ + "static/media/knowYourCommunity.0ac1dc9ba4765ca437c837b6f598c064.svg";
export { ForwardRef as ReactComponent };